import * as React from 'react'
import { Outlet, createRootRouteWithContext, Link } from '@tanstack/react-router'
import { QueryClient } from "@tanstack/react-query";
import { GenericAlert } from "@/components/generic-alert";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { useAuthentication } from "@/contexts/AuthenticationContext";
import { ReactNode, Suspense } from "react";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient,
  auth: ReturnType<typeof useAuthentication>
  customNav: () => ReactNode,
  hideFeedbackFooter: boolean,
  hideNavBar: boolean,
  removeContentPadding: boolean,
}>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
})

function RootComponent() {

  const TanStackRouterDevtools =
    import.meta.env.PROD
      ? () => null // Render nothing in production
      : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/react-router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      )

  const TanStackQueryDevtools =
    import.meta.env.PROD
      ? () => null // Render nothing in production
      : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/react-query-devtools').then((res) => ({
          default: res.ReactQueryDevtools,
        })),
      )

  return (
    <React.Fragment>
      <Outlet/>
      <Suspense>
        {/* <TanStackRouterDevtools position="bottom-right"/>
        <TanStackQueryDevtools buttonPosition="top-right"/> */}
      </Suspense>
    </React.Fragment>
  )
}

function NotFoundComponent() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <GenericAlert>
        <p className="text-xl mb-4">
          Page not found!
        </p>
        <Button>
          <Link to="/organization" className="flex flex-row gap-2 items-center">
            Go home
            <ChevronRight/>
          </Link>
        </Button>
      </GenericAlert>
    </div>
  )
}